import * as tslib_1 from "tslib";
/**
 * Class for functions
 */
var Functions = /** @class */ (function () {
    function Functions() {
    }
    /**
     * Creates a debounced function that delays invoking fn until after delay milliseconds
     * @param fn
     * @param delay
     */
    Functions.debouce = function (fn, delay) {
        if (delay === void 0) { delay = 0; }
        var timer = null;
        return function () {
            // @ts-ignore
            var context = this;
            var args = arguments;
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    };
    /**
     * Creates a throttled function that only invokes fn at most once per every interval milliseconds
     * @param fn
     * @param interval
     */
    Functions.throttle = function (fn, interval) {
        if (interval === void 0) { interval = 0; }
        var last = 0;
        return function () {
            // @ts-ignore
            var context = this;
            var now = Date.now();
            if (now - last > interval) {
                last = now;
                fn.apply(context, arguments);
            }
        };
    };
    /**
     * sleep
     * @param time 时间戳
     */
    Functions.sleep = function (time) {
        return new Promise(function (resolve) { return setTimeout(resolve, time); });
    };
    /**
     * 轮询
     * @param func 需要轮询的函数
     * @param assert 断言函数
     * @param count 轮询次数
     * @param interval 轮询间隔
     */
    Functions.polling = function (func, assert, count, interval) {
        var _this = this;
        if (count === void 0) { count = 8; }
        if (interval === void 0) { interval = 2000; }
        /**
         * 执行结果
         */
        var resp = null;
        /**
         * 计时器 id
         */
        var id = null;
        /**
         * 内部计数
         */
        var _count = 0;
        return new Promise(function (resolve, reject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            // 轮询方法
            function cstmInterval(func, interval) {
                return tslib_1.__awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        if (_count === count) {
                            // 次数到了就不执行
                            id && clearCstmInterval(id);
                            resolve(resp);
                            return [2 /*return*/];
                        }
                        id = setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var error_2;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, func()];
                                    case 1:
                                        resp = _a.sent();
                                        _count++;
                                        if (!assert(resp)) {
                                            cstmInterval(func, interval);
                                        }
                                        else {
                                            id && clearCstmInterval(id);
                                            resolve(resp);
                                        }
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_2 = _a.sent();
                                        reject(error_2);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }, interval);
                        return [2 /*return*/];
                    });
                });
            }
            // 清除计时器方法
            function clearCstmInterval(id) {
                clearTimeout(id);
            }
            var resp_first, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, func()];
                    case 1:
                        resp_first = _a.sent();
                        _count++;
                        if (!assert(resp_first)) {
                            cstmInterval(func, interval);
                        }
                        else {
                            resolve(resp_first);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        reject(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * timeout function
     * @param fn 异步函数
     * @param time 超时时间
     */
    Functions.timeoutPromise = function (fn, time) {
        if (time === void 0) { time = 5000; }
        var _timeout = Functions.sleep(time).then(function () {
            throw new Error('Operation timed out after ' + time + 'ms');
        });
        return Promise.race([fn(), _timeout]);
    };
    return Functions;
}());
export default Functions;
